import * as PlanningActual from '../../../services/planningActual.service';
import PlanningActualType from './PlanningActual.type';
import { toasterMsg } from '../../../Components/Toaster/Toaster';

export const fetchCategoryData = (data) => async (dispatch) => {
  try {
    const res = await PlanningActual.getPlanningActualData(data);

    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlanningActualType.CATEGORY2,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const autoSaveData = (data) => async () => {
  try {
    const res = await PlanningActual.postAutoSaveData(data);
    if (res.code === 200 && res.data) {
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
export const resetData = () => async (dispatch) => {
  try {
    await dispatch({
      type: PlanningActualType.RESET,
      payload: [],
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchSelectableYear = (data) => async (dispatch) => {
  try {
    const res = await PlanningActual.getYearsPlanningActualData(data);

    if (res.code === 200 && res.data) {
      console.log('wait herrrrrrrrrr');
      await dispatch({
        type: PlanningActualType.YEARSDATA,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
